import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { ProjectEstimatesStatusEnum } from '../../../common/pokCore/validation/enums';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { PermissionsEnum } from '../../../common/pokCore/authorization/permissions';
import { useAuth } from '../../../common/hooks/useAuth';
import { useTranslation } from '../../../common/hooks/useTranslation';
import ConfirmationButton from '../../../app/components/ConfirmationButton';

interface MarkerForFinanceProps {
  objectId: string;
  status: ProjectEstimatesStatusEnum;
  refresh: boolean;
  setRefresh: (refresh: boolean) => void;
}

export const MarkerForFinance: React.FC<MarkerForFinanceProps> = props => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('fvsLng');
  const notifications = useNotifications();
  const auth = useAuth();
  const authFinance = auth.check(PermissionsEnum.Finance);

  const handleChangeState = () => {
    if (props.objectId) {
      if (props.status === ProjectEstimatesStatusEnum.ReadyForInvoice) {
        pok.estimatesByMonth
          .changeToWithdrawn(props.objectId)
          .then(() => props.setRefresh(!props.refresh))
          .catch(errorResponse => {
            notifications.caughtError(errorResponse);
          });
      }
    }
  };

  return (
    <>
      {authFinance &&
        props.status === ProjectEstimatesStatusEnum.ReadyForInvoice && (
          <OverlayTrigger
            overlay={<Tooltip>{t(tk.finance.markerForFinance)}</Tooltip>}
          >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div onClick={e => e.stopPropagation()}>
              <ConfirmationButton
                onOK={handleChangeState}
                confirmation={t(tk.finance.askChangeToWithdrawn)}
                variant="outline-primary"
              >
                <Icon.ArrowDownLeftCircle size={20} />
              </ConfirmationButton>
            </div>
          </OverlayTrigger>
        )}
    </>
  );
};
